import { Box, Heading, Tag, TagLabel } from '@chakra-ui/react'
import React, { type Dispatch, type SetStateAction } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { type FilterBy, useUpdateSelectedFilterBy } from '@/components/Course/helpers'

const TypeFilter: React.FC<{
  disabled: boolean
  setPageDisabled: Dispatch<SetStateAction<boolean>>

  isModal?: boolean
  selectedType: FilterBy
  selectedStaging: {
    topics: Set<number>
    type: FilterBy
  }
  setSelectedStaging: Dispatch<
    SetStateAction<{
      topics: Set<number>
      type: FilterBy
    }>
  >
}> = ({
  disabled,
  setPageDisabled,
  isModal = false,
  selectedType,
  selectedStaging,
  setSelectedStaging,
}) => {
  const updateSelectedFilterBy = useUpdateSelectedFilterBy(setPageDisabled)

  const handleChange = React.useCallback(
    (filter: FilterBy) => {
      if (isModal) {
        if (selectedStaging.type === filter) {
          setSelectedStaging({ topics: selectedStaging.topics, type: null })
          return
        }
        setSelectedStaging({ topics: selectedStaging.topics, type: filter })
        return
      }
      if (selectedType === filter) {
        updateSelectedFilterBy(null)
        return
      }
      updateSelectedFilterBy(filter)
    },
    [selectedStaging, setSelectedStaging, selectedType, updateSelectedFilterBy, isModal]
  )

  return (
    <Box flex={1} textAlign="left">
      <Heading size="lg" as="h4" mb="14px">
        Format
      </Heading>
      <Tag
        variant="ghost"
        size="md"
        borderRadius="md"
        color={disabled ? 'fg.subtle' : 'fg.muted'}
        bgColor={
          (!isModal && selectedType === 'session') ||
          (isModal && selectedStaging.type === 'session')
            ? 'gray.muted'
            : 'bg'
        }
        mx={1}
        height={2}
        border={`1px solid ${chakraTokenToVar('border.emphasized')}`}
        _hover={{
          bgColor: 'gray.subtle',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onClick={() => (disabled ? null : handleChange('session'))}
      >
        <TagLabel>Session</TagLabel>
      </Tag>
      <Tag
        variant="ghost"
        size="md"
        borderRadius="md"
        bgColor={
          (!isModal && selectedType === 'series') || (isModal && selectedStaging.type === 'series')
            ? 'gray.muted'
            : 'bg'
        }
        color={disabled ? 'fg.subtle' : 'fg.muted'}
        mx={1}
        height={2}
        border={`1px solid ${chakraTokenToVar('border.emphasized')}`}
        _hover={{
          bgColor: 'gray.subtle',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onClick={() => (disabled ? null : handleChange('series'))}
      >
        <TagLabel>Series</TagLabel>
      </Tag>
    </Box>
  )
}

export default TypeFilter
